import React from "react";

const ChatMessage = ({ message, isBot = false, timestamp }) => {
  return (
    <div className={`flex ${isBot ? "justify-start" : "justify-end"} mb-4`}>
      <div
        className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg ${
          isBot
            ? "bg-gray-100 text-gray-800 border border-gray-200"
            : "bg-[#059669] text-white"
        }`}
      >
        {isBot && (
          <div className="flex items-center mb-1">
            <div className="w-2 h-2 bg-[#059669] rounded-full mr-2"></div>
            <span className="text-xs font-medium text-gray-600">Assistant</span>
          </div>
        )}
        <p className="text-sm leading-relaxed">{message}</p>
        {timestamp && (
          <p
            className={`text-xs mt-1 ${
              isBot ? "text-gray-500" : "text-green-100"
            }`}
          >
            {timestamp}
          </p>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
